module.exports = __webpack_public_path__ + "img/Calidad-R.445ffc4e.png";